
<div>
  <div
    v-if="visible"
    :class="['loader-wrapper', bounds ? 'loader-wrapper--bounded' : '']"
    :style="wrapperStyle"
  >
    <component
      :is="currentLoader"
      :msg="msg"
      :svg="svg"
      :svg-path="svgPath"
    />
  </div>
</div>
